/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 * Filename and corresponding read url for the metadata of a sample in the datasource
 * @export
 * @interface DatasourceRawSamplesMetadataDataRow
 *
 */
// create custom validators for the regexes
export interface DatasourceRawSamplesMetadataDataRow {
    /**
     *
     * #type string
     * #memberof DatasourceRawSamplesMetadataDataRow
        
        
         */
    fileName: string;
    /**
     * A URL which allows anyone in possession of said URL to access the resource
     * #type string
     * #memberof DatasourceRawSamplesMetadataDataRow
        
        
         */
    readUrl: string;
}
/**
 * Check if a given object implements the DatasourceRawSamplesMetadataDataRow interface.
 */
export function instanceOfDatasourceRawSamplesMetadataDataRow(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "readUrl" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const DatasourceRawSamplesMetadataDataRowTypiaAssertEquals = (input: any) => {
    return ((input: any): DatasourceRawSamplesMetadataDataRow => {
        const __is = (input: any, _exceptionable: boolean = true): input is DatasourceRawSamplesMetadataDataRow => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.fileName && "string" === typeof input.readUrl && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["fileName", "readUrl"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DatasourceRawSamplesMetadataDataRow => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.fileName || $guard(_exceptionable, {
                    path: _path + ".fileName",
                    expected: "string",
                    value: input.fileName
                })) && ("string" === typeof input.readUrl || $guard(_exceptionable, {
                    path: _path + ".readUrl",
                    expected: "string",
                    value: input.readUrl
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["fileName", "readUrl"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceRawSamplesMetadataDataRow",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceRawSamplesMetadataDataRow",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DatasourceRawSamplesMetadataDataRowTypiaAssertStringify = (input: DatasourceRawSamplesMetadataDataRow): string => {
    return ((input: any): string => { const assert = (input: any): DatasourceRawSamplesMetadataDataRow => {
        const __is = (input: any): input is DatasourceRawSamplesMetadataDataRow => {
            return "object" === typeof input && null !== input && ("string" === typeof (input as any).fileName && "string" === typeof (input as any).readUrl);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DatasourceRawSamplesMetadataDataRow => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.fileName || $guard(_exceptionable, {
                    path: _path + ".fileName",
                    expected: "string",
                    value: input.fileName
                })) && ("string" === typeof input.readUrl || $guard(_exceptionable, {
                    path: _path + ".readUrl",
                    expected: "string",
                    value: input.readUrl
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceRawSamplesMetadataDataRow",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceRawSamplesMetadataDataRow",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DatasourceRawSamplesMetadataDataRow): string => {
        const $string = (typia.createAssertStringify as any).string;
        return `{"fileName":${$string((input as any).fileName)},"readUrl":${$string((input as any).readUrl)}}`;
    }; return stringify(assert(input)); })(input);
};
export const DatasourceRawSamplesMetadataDataRowValidatorShape = {
    'fileName': yup.string().defined(),
    'readUrl': yup.string().defined(),
};
export const DatasourceRawSamplesMetadataDataRowValidator = yup.object().shape(DatasourceRawSamplesMetadataDataRowValidatorShape);
export const DatasourceRawSamplesMetadataDataRowStringifyShapeProperties: ObjectSchema['properties'] = {
    'fileName': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'readUrl': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
};
export const DatasourceRawSamplesMetadataDataRowStringifyShape: ObjectSchema = {
    title: 'DatasourceRawSamplesMetadataDataRow Stringifier',
    type: 'object',
    properties: {
        ...DatasourceRawSamplesMetadataDataRowStringifyShapeProperties
    },
    required: [
        'fileName',
        'readUrl',
    ],
};
export const DatasourceRawSamplesMetadataDataRowStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DatasourceRawSamplesMetadataDataRowStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DatasourceRawSamplesMetadataDataRowStringify: (data: DatasourceRawSamplesMetadataDataRow) => string = DatasourceRawSamplesMetadataDataRowStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DatasourceRawSamplesMetadataDataRowFromJSON(json: any): DatasourceRawSamplesMetadataDataRow {
    return DatasourceRawSamplesMetadataDataRowFromJSONTyped(json, false);
}
export function DatasourceRawSamplesMetadataDataRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasourceRawSamplesMetadataDataRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'fileName': json['fileName'],
        'readUrl': json['readUrl'],
    };
}
export function DatasourceRawSamplesMetadataDataRowToJSON(value?: DatasourceRawSamplesMetadataDataRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fileName': value.fileName,
        'readUrl': value.readUrl,
    };
}
